import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { SAVE_PROJECT } from "pages/development/projects/graphql";
import { useState } from "react";
import DimensionView from "./DimensionView";
import MaterialsView from "./MaterialsView";

const defaultValues = {
  size: { shape: "cube", cubeX: 10, cubeY: 10, cubeZ: 10 },
  weight: 100,
  pantone: "123C",
  remark: "test notes",
};

const ProductForm = ({ allMaterials, projectId, hide, originalData = {} }) => {
  const [saveProject, saveProjectRes] = useMutation(SAVE_PROJECT, {
    onCompleted() {
      Alert("success", "Product saved successfully!");
      hide();
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });

  const [product, setProduct] = useState({
    ...defaultValues,
    ...originalData,
  });

  function saveHandler() {
    saveProject({
      variables: {
        id: projectId,
        data: JSON.stringify(product, " ", 2),
      },
    });
  }

  return (
    <div className="text-sm">
      <div className="space-y-6">
        <DimensionView product={product} setProduct={setProduct} />
        <MaterialsView
          allMaterials={allMaterials}
          product={product}
          setProduct={setProduct}
        />
      </div>

      <div className="text-sm mt-6">
        <Button primary onClick={saveHandler} loading={saveProjectRes.loading}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default ProductForm;
